import {
    FormControl,
    IterateOptions
} from '../../../../components/FormUtilities'
import InputField from '../../../../components/InputField'
import SelectMultiple from '../../../../components/SelectMultiple'
import Toggle from '../../../../components/Toggle'
import { formInformation } from '../../storage'
import { useEffect } from 'react'

interface ProductOption {
    id: number
    name: string
}

interface CountryOption extends ProductOption {
    code: string
}

function SortDescription() {
    const { props, getError } = formInformation.useInput('name')
    const helper = getError(
        'ERROR-0000107',
        'Ya existe un producto con el mismo nombre'
    )

    return (
        <FormControl label="Descripción corta" required>
            <InputField
                {...props}
                placeholder="Ingresar descripción corta"
                autoFocus
                helper={helper || props.helper}
                regex={null}
            />
        </FormControl>
    )
}

function ManufacturerCode() {
    const { props } = formInformation.useInput('manufacturer_code')
    return (
        <FormControl label="Código Fabricante" required>
            <InputField
                {...props}
                placeholder="Ingresar código fabricante"
                maxLength={255}
            />
        </FormControl>
    )
}

function CountryAvailability() {
    const { props, data } = formInformation.useSelects<CountryOption>(
        'country_availability',
        '/v5.6/apis/product_options/countries'
    )
    return (
        <FormControl label="Disponibilidad País">
            <SelectMultiple
                {...props}
                placeholder="Seleccionar país(es)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

function isCountrySelected(countryId: number) {
    const availability = formInformation.store().country_availability || []
    return availability.some(c => parseInt(String(c.value), 10) === countryId)
}

function FiscalCodeNI() {
    const { props } = formInformation.useInput('fiscal_code_ni')
    const enabled = isCountrySelected(1)
    return (
        <FormControl label="Código Fiscal NI">
            <InputField
                {...props}
                placeholder="Ingresar código fiscal NI"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function FiscalCodeCR() {
    const { props } = formInformation.useInput('fiscal_code_cr')
    const enabled = isCountrySelected(2)
    return (
        <FormControl label="Código Fiscal CR" required={enabled}>
            <InputField
                {...props}
                placeholder="Ingresar código fiscal CR"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function FiscalCodePA() {
    const { props } = formInformation.useInput('fiscal_code_pa')
    const enabled = isCountrySelected(3)
    return (
        <FormControl label="Código Fiscal PA" required={enabled}>
            <InputField
                {...props}
                placeholder="Ingresar código fiscal PA"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function FiscalCodeVE() {
    const { props } = formInformation.useInput('fiscal_code_ve')
    const enabled = isCountrySelected(4)
    return (
        <FormControl label="Código Fiscal VE">
            <InputField
                {...props}
                placeholder="Ingresar código fiscal VE"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function CertificateToggle() {
    const { props: certificateProps } = formInformation.useCheck('certificate')

    useEffect(() => {
        formInformation.setProps(
            'certification',
            { disabled: !certificateProps.checked },
            true
        )
        if (!certificateProps.checked) {
            formInformation.setValue('certification', [], true)
        }
    }, [certificateProps.checked])

    return (
        <FormControl label="Certificado">
            <Toggle {...certificateProps} size="md" />
        </FormControl>
    )
}

function CertificationSelector() {
    const typeProductValue = formInformation.store().type_product?.value
    const { props, data } = formInformation.useSelects<ProductOption>(
        'certification',
        typeProductValue !== undefined
            ? `/v5.6/apis/product_options/certifications?type_product=${typeProductValue}`
            : '/v5.6/apis/product_options/certifications'
    )

    const resolvedOptions = (props.options || []).map(opt => {
        const found = data.find(
            item => item.id.toString() === String(opt.value)
        )
        return found ? { label: found.name, value: opt.value } : opt
    })

    return (
        <FormControl label="Certificaciones">
            <SelectMultiple
                {...props}
                options={resolvedOptions}
                placeholder="Seleccionar certificación(es)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

export default function Fields() {
    return (
        <>
            <SortDescription />
            <ManufacturerCode />
            <CountryAvailability />
            <FiscalCodeNI />
            <FiscalCodeCR />
            <FiscalCodePA />
            <FiscalCodeVE />
            <CertificateToggle />
            <CertificationSelector />
        </>
    )
}
